"use client";

import { useRef } from "react";
import type { TurnstileInstance } from "@marsidev/react-turnstile";
import { IS_TURNSTILE_DISABLED } from "./turnstile-widget";

export function useTurnstile() {
  const turnstileRef = useRef<TurnstileInstance>(undefined);

  const takeTurnstileToken = async () => {
    if (IS_TURNSTILE_DISABLED) return "development";

    const widget = turnstileRef.current;
    if (!widget) throw new Error("The verification widget is not on the page.");

    const token = await widget.getResponsePromise();
    // Tokens are single-use, so start the next challenge now for a retry.
    widget.reset();

    return token;
  };

  return { turnstileRef, takeTurnstileToken };
}
